const profileStaffEN = {
	header: {
		title: "Shop Profile",
		preview: "Preview",
		edit: "Edit",
	},

	images: {
		intro: "Your first photo is the cover customers see.",
		addPhoto: "Add Photo",
		reviews: "reviews",
		noPhotos: "No photos yet",
		needPhoto: "Add at least one photo before saving.",
		title: "Images",
		makeCover: "Set as cover",
		replace: "Replace",
		delete: "Delete",
		cover: "Cover",
		reorderHint: "Hold a photo and drag it to change the order.",
		noImageSelected: "No image selected",
		noImage: "No image",
		confirmDelete: "Are you sure you want to delete this image?",
		invalidImage: "That file isn't a valid image. Please choose a photo (JPG, PNG, etc.).",
		tooLarge: "That image is too large (over 20MB). Please choose a smaller photo.",
		uploadFailed: "We couldn't upload the image. Please try again.",
		cropTitle: "Crop photo",
		zoom: "Zoom",
	},

	services: {
		intro: "Tick everything you are trained to do.",
		serviceType: {
			home: "Home service",
			online: "Online",
		},
		title: "Services",
		add: "+ Add",
		empty: "No services listed yet.",
		emptyCategory: "No services in this category",
		name: "Service name",
		price: "Price",
		hours: "Hours",
		minutes: "Minutes",
		description: "Description",
		category: "Category",
		placeholderName: "Service name",
		placeholderDescription: "Service description",
		homeService: "Home service",
		inShop: "In shop",
		transitTimeLabel: "Transit time before service (minutes)",
		servicesIOffer: "Services I Offer",
		addServices: "+ Add services",
		servicesCount: "services",
	},

	actions: {
		saveChanges: "Save Changes",
		cancel: "Cancel",
	},

	errors: {
		fillAllFields: "Please fill in all required fields.",
	},

	staffInfo: {
		intro: "Your name and bio as customers will see them.",
		title: "Edit Profile",
		firstName: "First Name",
		lastName: "Last Name",
		bio: "Bio",
		phone: "Phone Number",
	},

	sidebar: {
		editServices: "Edit Services",
		location: {
			title: "Location",
		},
		contact: {
			title: "Contact Details",
			phone: "Phone Number",
			email: "Email",
			noPhone: "No phone available",
			noEmail: "No email provided",
			socialTitle: "Social Media",
			website: "Website",
			instagram: "Instagram",
			facebook: "Facebook",
			tiktok: "TikTok",
		},
		hours: {
			title: "Opening Hours",
			show: "Show more hours",
			hide: "Hide hours",
			closed: "Closed",
			edit: "Edit Hours",
			addHours: "Add opening hours",
		},
		staff: {
			title: "Team",
			edit: "Manage Team",
			roles: {
				admin: "Admin",
				staff: "Staff",
				owner: "Owner",
			},
			noStaff: "No team members yet.",
			addStaff: "Invite Team Member",
			remove: "Remove",
			editRole: "Change Role",
		},
	},

	modal: {
		shopInfo: {
			title: "Shop Information",
			subTitle: "Details",
			name: "Shop Name",
			description: "Description",
			address: "Address",
			city: "City",
			country: "Country",
		},
		contact: {
			title: "Contact Details",
			description: "Update phone, email and social media links.",
		},
		hours: {
			title: "Business Hours",
			description: "Set open and close times for each day.",
			open: "Open",
			close: "Close",
			closed: "Closed",
		},
		team: {
			title: "Team Members",
			description: "Manage staff members and their roles.",
			addButton: "Invite Member",
			close: "Close",
			save: "Save",
		},
	},

	categories: {
		cannotDeleteWithServices: "Remove or move all services before deleting this category",
		addCategory: "Add category",
		newCategory: "New category",
	},

	addAddress: "Add address",
	addServices: "Edit services",
	addFirstServices: "Edit services",
	addShopName: "Add shop name",
	noReviewsyet: "No reviews yet",
	addAttributes: "+ Add attributes",
	addDescription: "Add a short description about your business",
};

export default profileStaffEN;